import { useEffect, useState } from 'react'

const breakpoints = {
  xs: 321,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1700
}

interface Breakpoints {
  xs: number
  sm: number
  md: number
  lg: number
  xl: number
}

export default (breakpoint: keyof Breakpoints) => {
  const isClient = typeof window === 'object'

  const getWidth = () => (isClient ? window.innerWidth : 0)

  const isMatch = (width: number) => width > breakpoints[breakpoint]
  const [match, setMatchFlag] = useState(() => isMatch(getWidth()))

  useEffect(() => {
    if (!isClient) {
      return
    }

    function handleResize() {
      const width = getWidth()
      setMatchFlag(isMatch(width))
    }

    window.addEventListener('resize', handleResize)

    // eslint-disable-next-line
    return () => window.removeEventListener('resize', handleResize)
  }) // Empty array ensures that effect is only run on mount and unmount

  return match
}
